import { Operators, OperatorsDef, } from "@/components/fields/base/BaseSearchField";
/** Opérateur de recherche pour le champ de type link*/
export var operators = [
    OperatorsDef[Operators.OPERATOR_EQUAL],
    OperatorsDef[Operators.OPERATOR_NOT_EQUAL],
    OperatorsDef[Operators.OPERATOR_IN],
    OperatorsDef[Operators.OPERATOR_NOT_IN],
];
